// extracted by mini-css-extract-plugin
module.exports = {"item":"People_item__1l7K2","content":"People_content__3BXS9","title":"People_title__30Eh1","description":"People_description__1M2U4","header":"People_header__fP1Yq"};